export const brandName = "NexGen Web Designs";

export const phoneNumber = "+918331889448";

export const whatsappNumber = "+918330920858";

export const whatsappNumber1 = "+918331889448";

export const whatsappLink = `https://api.whatsapp.com/send/?phone=${whatsappNumber}&text=Hello%21%20I%27m%20interested%20in%20your%20web%20development%20services.&type=phone_number&app_absent=0`;

export const whatsappLink1 = `https://api.whatsapp.com/send/?phone=${whatsappNumber1}&text=Hello%21%20I%27m%20interested%20in%20your%20web%20development%20services.&type=phone_number&app_absent=0`;

export const whatsappSupportLink = `https://api.whatsapp.com/send/?phone=${whatsappNumber1}&text=Hello%20NexGen%20Web%20Designs%20Support%20Team%2C%20I%20need%20assistance%20with%20my%20website.%20Could%20you%20please%20help%20me%3F&type=phone_number&app_absent=0`;

export const emailAddress = "info@nexgenwebdesigns.com";

export const emailAddress1 = "contact@nexgenwebdesigns.com";

export const address = "Katrenikona, Andhra Pradesh, India.";

export const address2 = "Kondapur, Hyderabad, India.";

export const fullAddress2 =
  "1-114/C, Vutla Sattaiah Colony, Hanuman Nagar, Raghavendra Colony, Hyderabad, Kondapur, Telangana_500084";

export const fullAddress1 =
  "1-47 , Santa Market , Katrenikona , katrenikona Mandal, Konaseema District, Andhra Pradesh_533212";

export const maintainence = false;

export const frontendUrl = "https://www.nexgenwebdesigns.com";

// export const serverUrl = "http://localhost:4000/api";
export const serverUrl = "https://nexgenwebdesignsbackend.onrender.com/api";
// export const serverUrl =
//   "https://nexgenwebdesignsbackend-l9zw.onrender.com/api";
